export default "__VITE_ASSET__CwqZ2US8__"